var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-center-column" },
    [
      _c("img", {
        staticClass: "title-img",
        attrs: { src: require("@/assets/home/banner_title.png"), alt: "" },
      }),
      _c(
        "el-button",
        {
          staticClass: "apple-btn",
          attrs: { type: "primary", round: "" },
          on: {
            click: function ($event) {
              return _vm.goApply()
            },
          },
        },
        [_vm._v("申请入驻")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }